module.exports = __webpack_public_path__ + "img/3.91f7e775.png";